import React from "react";
import PropTypes from "prop-types";
import InputField from "components/Input";
import SelectCountry from "components/block/SelectCountry";
import "./index.scss";

const AddressFields = ({
  user,
  handleSelectCountry,
  handleInputChange,
  isDisabled,
  country,
  errors,
  isOptional,
  isDisabledCountry,
}) => {
  return (
    <>
      <InputField
        label="Street Address"
        id="address1"
        value={user?.address1 || ""}
        onChange={(e) => handleInputChange(e)}
        disabled={isDisabled}
        error={errors?.address1}
      />
      <InputField
        label="Apartment, Suite, Unit"
        id="address2"
        value={user?.address2 || ""}
        onChange={(e) => handleInputChange(e)}
        disabled={isDisabled}
        error={errors?.address2}
      />
      {isOptional && <p className="details">(optional)</p>}
      <div className="form-group">
        <InputField
          label="City/Suburb"
          id="city"
          value={user?.city || ""}
          onChange={(e) => handleInputChange(e)}
          disabled={isDisabled}
          error={errors?.city}
        />
        {/* For future implementation       
        <div className="input-field">
          {errors?.country && (
            <label htmlFor="state" className="label error">
              {errors?.state}
            </label>
          )}
          <RegionDropdown
            country={country.toUpperCase()}
            value={states}
            onChange={(val) => handleSelectState(val)}
            className={`location-selector ${errors?.state ? "error" : ""}`}
            blankOptionLabel="No country selected"
            defaultOptionLabel="Select a State/Province"
            disabled={isDisabled}
            label="State"
            id="state"
            countryValueType="short"
            disableWhenEmpty
          />
          <label className="location-label">State/Province</label>
        </div> */}
        <InputField
          label="State/Province"
          id="state"
          value={user?.state}
          onChange={(e) => handleInputChange(e)}
          disabled={isDisabled}
          error={errors?.state}
        />
      </div>
      <div className="form-group -two-one-one">
        <SelectCountry
          label="Country"
          value={country.toUpperCase()}
          onChange={(val) => handleSelectCountry(val)}
          disabled={isDisabledCountry || isDisabled}
          error={errors?.country}
          errorMessage={errors?.country}
        />
        <InputField
          label="Zip or Postal Code"
          id="zipCode"
          value={user?.zipCode || ""}
          onChange={(e) => handleInputChange(e)}
          disabled={isDisabled}
          error={errors?.zipCode}
        />
      </div>
    </>
  );
};

AddressFields.defaultProps = {
  errors: {},
  isOptional: false,
};
AddressFields.propTypes = {
  user: PropTypes.shape({
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    zipCode: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
  }).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSelectCountry: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isDisabledCountry: PropTypes.bool.isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  errors: PropTypes.shape({
    address1: PropTypes.string,
    suburb: PropTypes.string,
    zipCode: PropTypes.string,
    country: PropTypes.string,
    state: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
  }),
  isOptional: PropTypes.bool,
};
export default AddressFields;
